import React, { Component } from "react";

import { withRouter } from "react-router-dom";

import { Alert } from "reactstrap";
import EnterpriseConfigProgress from "./EnterpriseConfigProgress";

import LogoUploader from "../../Containers/EnterpriseConfig/LogoUploader";
import ERPIntegration from "../../Containers/EnterpriseConfig/ERPIntegration/ERPIntegration";
import ExistingVendorImport from "../../Containers/EnterpriseConfig/ExistingVendorImport";

import UtilButton from "../../Controls/UtilButton";
import WorkFlows from "../../Containers/EnterpriseConfig/WorkFlows";

class EnterpriseConfigStep01 extends Component {
  onNextClick = (arg) => {
    this.props.history.replace(arg);
  };

  render() {
    return (
      <section id="isuppli-enterpriseconfig-step-01">
        <EnterpriseConfigProgress currentStep={1} />

        <div className="padding-lr-10vw">
          <div className="row top-margin-90px">
            <div className="col-12 col-sm-5">
              <div>
                <h3 className="margin-null">STEP 01</h3>
              </div>
              <div>
                <h1>GENERAL SETTINGS</h1>
              </div>
            </div>

            <div className="col-12 col-sm-7 justify-center flex-column">
              Information blurp about why they need to provide information for
              “general settings”.
            </div>
          </div>

          <div className="top-margin-30px">
            <Alert color="info">
              Please fill in the required fields below. All fields are mandatory
              unless stated otherwise.
            </Alert>
          </div>

          <LogoUploader />

          <hr />

          <WorkFlows />

          <hr />

          <ERPIntegration
            additional={{}}
            onInputChangeCallback={() => {}}
          />

          <hr />

          <ExistingVendorImport />

          <div className="top-bottom-margin-40px">&nbsp;</div>

          <hr className="margin-null" />

          <div className="row">
            <div className="col-12 col-sm-5 block-sm justify-start">
              <UtilButton
                text="BACK"
                background="clear"
                actionArg="/registration/supinfo"
                location="bottom"
                actionCallback={(arg) => this.props.history.replace(arg)}
              />
            </div>

            <div className="col-12 col-sm-7 block-sm justify-end">
              <UtilButton
                text="SAVE AND CONTINUE LATER"
                background="active"
                actionArg="s"
                location="bottom"
                actionCallback={() => {}}
              />

              <div className="left-margin-10px" />

              <UtilButton
                text="NEXT - SUPPLIER CATEGORIES"
                background="attention"
                actionArg="/mycompany/configuration/catinfo"
                location="bottom"
                actionCallback={this.onNextClick}
              />
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default withRouter(EnterpriseConfigStep01);
